/**
 * Persists a public visitor's intent to enrol in a programme so that the
 * intent survives login / signup, and then resolves into an actual enrolment
 * record once the user is authenticated.
 *
 * Storage is localStorage (small, opaque, one entry per visitor).
 *   { id: "<programme_id>", code: "<SBL-PXX>", title: "...", at: ISO }
 */
const KEY = "sbl_pending_enrollment_v1";

export function setPendingEnrollment(prog) {
  if (!prog?.id) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({
      id: prog.id,
      code: prog.code || "",
      title: prog.title || "",
      at: new Date().toISOString(),
    }));
  } catch { /* private mode etc — ignore */ }
}

export function getPendingEnrollment() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function clearPendingEnrollment() {
  try { localStorage.removeItem(KEY); } catch { /* */ }
}
